export default "__VITE_ASSET__DwHzKYS3__"